export default "__VITE_ASSET__a80567a1__"